<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            text
            icon
            color="primary"
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon medium>
              add
            </v-icon>      
          </v-btn>
        </template>
        <span>Add Skill Requirements</span>
      </v-tooltip>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      :loading="loading"
      color="green"
      title="Job Requirements"
      text="Add Job Requirements"
      class="mb-0"
    >
      <template v-if="!loading">
        <p
          v-if="noOfSkills <= 0"
          class="mt-2"
        > 
          Skills of this job description are all added 
          
          <span v-if="$hasPermissionTo(['setup job description view'])">
            , add more at 
            <router-link
              to="/job-descriptions"
            >         
              <span>Job Descriptions Setup Page</span>
            </router-link> 
          </span>
        </p>
        <v-container v-else>
          <v-row 
             
            class="horizontal-scroll-xl"
          >
            <span 
              v-for="skill in skills" 
              :key="skill.id"
              class="pa-2 text-center"
            >
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-avatar
                    size="30"
                    tile
                    v-on="on" 
                  >
                    <img
                      :src="skill.image_url"
                      alt="skill logo"
                    >
                  </v-avatar>
                </template>
                {{ skill.name }}
              </v-tooltip>
              <v-menu
                :close-on-content-click="false"
                :nudge-bottom="20"
                max-width="550px"
                max-height="550px"
                open-on-hover
                bottom
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-rating     
                      v-model="skill.rating"
                      :length="skill.levels.length"
                      small
                      hover
                    />
                  </div>
                </template>

                <v-card>
                  <v-data-table
                    v-show="skill.levels.length > 0"
                    :headers="levelHeaders"
                    :items="skill.levels"
                    hide-default-footer
                  >
                    <template v-slot:item="props">
                      <tr :class="{active: props.item.level === skill.rating}">
                        <td class="text-right">{{ props.item.level }}</td>
                        <td class="text-justify py-2">{{ props.item.description }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card>
              </v-menu>
            </span>
          </v-row>
        </v-container>
      </template>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :disabled="noOfSkills <= 0"
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Add requirement
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      positionId: {
        type: Number,
        required: true,
      },
      gradeId: {
        type: Number,
        required: true,
      },
      jobDescriptionId: {
        type: Number,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        progressing: false,
        dialog: null,
        existingRequirements: [],
        description: {},
        rating: [],
        skills: [],
        levelHeaders: [
          {
            text: 'Level',
            value: 'level',
            sortable: false, 
          },
          { 
            text: 'Description', 
            align: 'left', 
            value: 'description',
            sortable: false, 
          },
        ],
      }
    },
    computed: {    
      noOfSkills () {
        return this.skills.length
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
    },
    methods: {
      loadData () {
        this.loading = true 
      
        Promise.all([
          this.$api.positionJobRequirements().list(this.positionId, this.gradeId),
          this.$api.jobDescriptions().show(this.jobDescriptionId),
        ])
          .then(([requirements, description]) => {
            this.existingRequirements = requirements.data
            this.description = description.data

            this.extractSkills()

            this.loading = false
          })
      },
      extractSkills () {      
        let existingSkillIds = this.existingRequirements
          .filter(requirement => requirement.job_requirement.job_description_id === this.jobDescriptionId)
          .map(requirement => requirement.skill_level.skill_id)

        this.skills = (this.description.skills || []).filter(skill => {
          return !existingSkillIds.includes(skill.id)
        }).map(skill => {
          return { ...skill, rating: 1 }
        })   
      },
      submitForm () {
        this.progressing = true

        this.$api.positionJobRequirements().create(this.prepareFormData())
          .then(response => {
            this.$emit('added')
            this.$snack({ message: response.data.status })

            this.dialog = false
          })
          .catch(() => {})
          .then(() => {
            this.progressing = false
          })
      },
      prepareFormData () {
        return this.skills.map(skill => {
          return {
            position_id: this.positionId,
            position_category_rank_id: this.gradeId,
            job_description_skill_id: skill.pivot.id,
            skill_level_id: skill.levels[skill.rating - 1].id,
          }
        })
      },
    },
  }
</script>

<style lang="css" scoped>
::v-deep .v-rating .v-icon{
  padding:0px;
}

::v-deep .v-rating {
  width:100px;
}

.v-menu {
  display: block;
}

.horizontal-scroll-xl{
  overflow-x:hidden; 
  overflow-y:hidden; 
  width:30vw;
}
</style>
